import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('IssueFormAssetsController', IssueFormAssetsController);

    function IssueFormAssetsController($scope, $http) {
        var vm = this;
        init();

        function init() {
            vm.getAssetChildren = function (assetId) {
                return $http.get(`/api/v1/assets/${assetId}/`);
            };

            vm.onAssetChange = onAssetChange;

            watchAvailableAssets();
        }

        function onAssetChange() {
            vm.getAssetChildren(vm.selectedAsset[0].asset_id).then(
                (response) => {
                    vm.selectedAsset[0].children = response.data.children;
                },
            );
        }

        function watchAvailableAssets() {
            $scope.$watch(
                function () {
                    return vm.availableAssets;
                },
                function () {
                    vm.componentAssets = angular.copy(vm.availableAssets);
                    if (vm.selectedAsset[0] && vm.selectedAsset[0].asset_id) {
                        onAssetChange();
                    }
                },
                true,
            );
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/issue_forms/fragments/assets/assets.controller.ts